
document.addEventListener('DOMContentLoaded', () => {
  const nav = document.querySelector('.category-club-nav');
  if (!nav) return;

  const items = nav.querySelectorAll('.category-club-nav__item--has-dropdown');

  const closeAll = () => {
    items.forEach((item) => {
      item.classList.remove('is-open');
      const trigger = item.querySelector('.category-club-nav__link');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  };

  items.forEach((item) => {
    const trigger = item.querySelector('.category-club-nav__link');
    if (!trigger) return;

    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-haspopup', 'true');

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const isOpen = item.classList.contains('is-open');
      closeAll();

      if (!isOpen) {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.category-club-nav')) {
      closeAll();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAll();
    }
  });
});
